var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1812 8.06316L17.7485 2.6304C17.3002 2.18213 16.8455 1.95483 16.3971 1.95483C15.7814 1.95483 15.0625 2.42312 15.0625 3.74293V5.59247C11.1154 5.76451 7.42941 7.38324 4.61803 10.1945C1.64034 13.172 0.00028125 17.1308 0 21.3418C0 21.6443 0.1935 21.913 0.480469 22.0088C0.553734 22.0332 0.628734 22.0449 0.703031 22.0449C0.919922 22.0449 1.12988 21.9443 1.26525 21.7641C4.58489 17.3454 9.5827 14.734 15.0625 14.5279V16.349C15.0625 17.6687 15.7814 18.1371 16.3971 18.1371H16.3972C16.8456 18.1371 17.3003 17.9098 17.7485 17.4616L23.1812 12.0287C23.7092 11.5008 24 10.7967 24 10.0459C24 9.29532 23.7092 8.59112 23.1812 8.06316Z",
    fill: "#FFB829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareShare);
export default __webpack_public_path__ + "static/media/share-share.e9df32b721251677af9f566a5d77d379.svg";
export { ForwardRef as ReactComponent };